import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>
          Learn Faster. <br />
          Remember Longer.
        </h1>
        <p>
          Một nền tảng học tập hiện đại, gọn gàng, và đủ thông minh
          để không làm bạn ghét việc học.
        </p>
        <div className="hero-actions">
          <Link to="/category"className="btn primary">Bắt đầu ngay</Link>
          {/* <button className="btn ghost disable">Xem demo</button> */}
        </div>
      </div>

      <div className="hero-visual">
        <div className="card floating a">Flashcards</div>
        <div className="card floating b">Spaced Repetition</div>
        <div className="card floating c">AI Support</div>
      </div>
    </section>
  );
}
